import { render, staticRenderFns } from "./KioskHeader.vue?vue&type=template&id=677dff5b&scoped=true"
import script from "./KioskHeader.vue?vue&type=script&lang=js"
export * from "./KioskHeader.vue?vue&type=script&lang=js"
import style0 from "./KioskHeader.vue?vue&type=style&index=0&id=677dff5b&prod&lang=scss&scoped=true"
import style1 from "./KioskHeader.vue?vue&type=style&index=1&id=677dff5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677dff5b",
  null
  
)

export default component.exports